type Ascoltatore = (...argomenti: any[]) => void;

/**
 * Emettitore di eventi per le notifiche in tempo reale, al posto di `new Vue()`.
 *
 * Prima era letteralmente un'istanza di Vue usata solo per `$on`/`$emit`. In Vue 3 non esiste piu ne
 * il costruttore globale ne quei metodi sulle istanze: erano stati rimossi proprio perche l'uso piu
 * diffuso era questo, cioe un bus travestito da componente.
 *
 * Si conservano i nomi `$on` / `$emit` / `$off` di proposito: i punti chiamanti - `App.ts` e
 * `signalr.ts` - restano identici, e la sostituzione non si allarga oltre questo file. Non e nostalgia
 * di Vue 2: e limitare la superficie di una modifica che non ha niente da insegnare.
 *
 * Niente `mitt` o simili: sono venti righe, e una dipendenza in piu su un progetto che ne sta
 * togliendo dodici sarebbe un cattivo affare.
 */
class BusEventi {
  private ascoltatori = new Map<string, Set<Ascoltatore>>();

  $on(evento: string, ascoltatore: Ascoltatore) {
    if (!this.ascoltatori.has(evento)) this.ascoltatori.set(evento, new Set());
    this.ascoltatori.get(evento)!.add(ascoltatore);
  }

  $off(evento: string, ascoltatore?: Ascoltatore) {
    if (!ascoltatore) {
      this.ascoltatori.delete(evento);
      return;
    }
    this.ascoltatori.get(evento)?.delete(ascoltatore);
  }

  $emit(evento: string, ...argomenti: any[]) {
    // Si itera su una copia: un ascoltatore che si disiscrive mentre viene notificato altrimenti
    // modificherebbe l'insieme durante il ciclo.
    [...(this.ascoltatori.get(evento) ?? [])].forEach((ascoltatore) => ascoltatore(...argomenti));
  }
}

export const eventBus = new BusEventi();
